import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/primitives";
import { demoNotice } from "@/data/site";
import { Check, Loader2 } from "lucide-react";

const empty = { name: "", email: "", phone: "", subject: "General Inquiry", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(empty);
  const [loading] = useState(false);
  const [done] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  // Demo site: no data is submitted — show the portfolio notice instead.
  const submit = (e) => {
    e.preventDefault();
    window.alert(demoNotice);
  };

  if (done) {
    return (
      <div className="flex flex-col items-center rounded-2xl border border-[var(--border)] bg-[var(--surface)] p-10 text-center" data-testid="contact-success">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--primary)]/12 text-[var(--primary)]">
          <Check size={26} />
        </div>
        <h3 className="mt-5 font-heading text-2xl font-light text-[var(--fg)]">Message received</h3>
        <p className="mt-2 max-w-sm text-sm text-[var(--muted-fg)]">
          Thanks for reaching out. A member of our team will respond within one business day.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4 rounded-2xl border border-[var(--border)] bg-[var(--surface)] p-6 sm:p-8" data-testid="contact-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <Label htmlFor="c-name">Full name *</Label>
          <Input id="c-name" data-testid="contact-name" value={form.name} onChange={update("name")} className="mt-1.5" placeholder="Jane Doe" />
        </div>
        <div>
          <Label htmlFor="c-phone">Phone</Label>
          <Input id="c-phone" data-testid="contact-phone" value={form.phone} onChange={update("phone")} className="mt-1.5" placeholder="(212) 555-0142" />
        </div>
      </div>
      <div>
        <Label htmlFor="c-email">Email *</Label>
        <Input id="c-email" type="email" data-testid="contact-email" value={form.email} onChange={update("email")} className="mt-1.5" placeholder="jane@email.com" />
      </div>
      <div>
        <Label htmlFor="c-subject">Subject</Label>
        <Input id="c-subject" data-testid="contact-subject" value={form.subject} onChange={update("subject")} className="mt-1.5" />
      </div>
      <div>
        <Label htmlFor="c-message">How can we help? *</Label>
        <Textarea id="c-message" data-testid="contact-message" value={form.message} onChange={update("message")} className="mt-1.5" rows={5} placeholder="Tell us a little about what you're looking for…" />
      </div>
      <Button type="submit" size="lg" disabled={loading} data-testid="contact-submit" className="w-full">
        {loading ? <><Loader2 size={16} className="animate-spin" /> Sending…</> : "Send Message"}
      </Button>
    </form>
  );
};
